var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgOats = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22V6",
    stroke: "#BFA76A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 4,
    rx: 1.5,
    ry: 2.5,
    transform: "rotate(-20 9.5 4)",
    fill: "#BFA76A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5,
    cy: 4,
    rx: 1.5,
    ry: 2.5,
    transform: "rotate(20 14.5 4)",
    fill: "#BFA76A"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 7.5,
    rx: 1.3,
    ry: 2.2,
    transform: "rotate(-30 8 7.5)",
    fill: "#BFA76A"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 7.5,
    rx: 1.3,
    ry: 2.2,
    transform: "rotate(30 16 7.5)",
    fill: "#BFA76A"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 11,
    rx: 1.2,
    ry: 2,
    transform: "rotate(-25 9 11)",
    fill: "#BFA76A"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 11,
    rx: 1.2,
    ry: 2,
    transform: "rotate(25 15 11)",
    fill: "#BFA76A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOats);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/oats.fb8724fa796a5e6ef13906d509ced48d.svg";